import React, { Component } from 'react';
import { Pagination, Spin, Button, Modal, Tooltip } from 'antd';
import { UndoOutlined, CloseOutlined, SendOutlined, FileDoneOutlined, HistoryOutlined } from '@ant-design/icons';
import { patientPendingSchema } from '../../schema/bill-tacking';
import { preauthSchema, preauthFileSchema } from '../../schema/preauthform';
import Select2 from '../../components/FormComponent/select2';
import Select2multiple from '../../components/FormComponent/select2/multiple';
import moment from 'moment';
import networkList from '../../constants/networkList';
import postService from '../../services/httpService';
import Counselling_upload from '../Counselling/newCounsellingForms/uploadDocument';
import New_Counselling_upload from '../Counselling/newCounsellingForms/newFileUploadDocuments';
import Storage from '../../services/local-store';
import userTrackService from '../../services/usertrack-service';
import Tableantd from '../../components/version2form_component/table/antd';
import DateRange from '../../components/FormComponent/DateRange';
import { CSVLink } from "react-csv";
import { UPLOAD_URL } from '../../../src/constants/app-constants';

var url = window.location.href
var arr = url.split("/");
var hostname = arr[0] + "//" + arr[2]


const {homepage} = networkList;
let i = 0;
class PerAuthWorklistNew extends Component {
    csvLink = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            'loadding': false,
            'page_data_count': 1,
            'search_key': '',
            previlege_data: [],
            responseData: [],
            tableHead: [],
            page_length: 20,
            'total_items': 0,
            dateTo: moment().format('YYYY-MM-DD'),
            dateFrom: moment().subtract(7, 'd').format('YYYY-MM-DD'),
            'downloadtbody': [],
            downloadStatus: 0,
            tbody: [],
            "doctor_id": [],
            "department_name": [],
            preauthSchema: JSON.parse(JSON.stringify(preauthSchema['feilds'])),
            preauthdata: [],
            viewpdf: false,
            ViewURLPDF: '',
            patientHistory: [],
            thead: [],
            checked: true,
            preauthFileSchema: preauthFileSchema['feilds'],
            pre_auth_submits:'',
            insurance_status:'',
            fc_payer_type:'',
            hims_payer_type:'',
            ViewURLPDF: ''
        }
    }

    componentDidMount() {
        try {
        let tableHead = [{
            'key': 'ip_no',
            'text': 'IP number'
        }, {
            'key': 'umr_no',
            'text': 'UMR number'
        }, {
            'key': 'patient_name',
            'text': 'Patient Name'
        }, {
            'key': 'phone_number',
            'text': 'Phone Number'
        }, {
            'key': 'date_of_counselling',
            'text': 'date of counselling'
        }, {
            'key': 'doctor_name',
            'text': 'Doctor Name'
        }, {
            'key': 'department_name',
            'text': 'Department Name'
        }, {
            'key': 'unit_name',
            'text': 'Unit Name'
        },
        {
            'key': 'rn_preauth_submitted',
            'text': 'Pre-auth Submitted'
        },
        {
            'key': 'payer_reponse_remarks',
            'text': 'Insurance Status'
        },
        {
            'key': 'fc_payer_type',
            'text': 'FC Payer Type'
        },
        {
            'key': 'hims_payer_type',
            'text': 'HIMS Payer Type'
        },
        {
            'key': 'rn_preauth_requested_time',
            // 'text': 'Preauth Submission Date'
            'text': 'Pre-Auth Triggered Time'
        },
        {
            'key': 'rn_preauth_submitted_date',
            'text': 'Pre-Auth Requested Time'
        }, {
            'key': 'payer_updated_at',
            'text': 'Preauth Response Received Date'
        },
        {
            'key': 'payer_approved_amount',
            'text': 'Approved Amount(Rs.)'
        },
        {
            'key': 'remedinet_remarks',
            'text': 'Remedinet Remarks'
        },
        {
            'key': 'approval_file_name',
            'text': 'Document received from Remedinet'
        },
        {
            'key': 'action',
            'text': 'Action'
        }

        ];
        let formSchema = Object.assign({}, patientPendingSchema);
        formSchema['feilds'].map((feild, key) => {
            if (feild.name === 'doctorid') {
                formSchema['feilds'][key]['value'] = null;
                formSchema['feilds'][key]['valid'] = false;
                formSchema['feilds'][key]['errors'] = [];
                formSchema['feilds'][key]['text'] = 'Doctor';
            } else if (feild.name === 'pendingDocs_departmentbyunit') {
                formSchema['feilds'][key]['value'] = null;
                formSchema['feilds'][key]['valid'] = false;
                formSchema['feilds'][key]['errors'] = [];
                formSchema['feilds'][key]['text'] = 'Department';
            } else if (feild.name === 'pre_auth_submitted') {
                formSchema['feilds'][key]['value'] = null;
                formSchema['feilds'][key]['valid'] = false;
                formSchema['feilds'][key]['errors'] = [];
                formSchema['feilds'][key]['text'] = 'Pre-Auth Submitted';
            }
            else if (feild.name === 'insurance_status') {
                formSchema['feilds'][key]['value'] = null;
                formSchema['feilds'][key]['valid'] = false;
                formSchema['feilds'][key]['errors'] = [];
                formSchema['feilds'][key]['text'] = 'Insurance Status';
            }
            else {
                formSchema['feilds'][key]['value'] = null;
                formSchema['feilds'][key]['valid'] = false;
                formSchema['feilds'][key]['errors'] = [];
                delete formSchema['feilds'][key]['text'];
            }


        })
        this.setState({ activePage: 1, totalItemsCount: 0, 'formData': formSchema['feilds'], 'tableHead': tableHead, search_key: '' }, () => {
            this.renderBody();
        });
    } catch (error) {
        console.log(error);
        this.setState((state) => ({ 'loadding': false }));
        Modal.error({
            title: 'Error Message',
            content: 'Oops, Something is wrong. Please try again.',
        })
    }

        // this.interval = setInterval(() => { this.renderBody() }, 8000);
    }

    componentWillUnmount() {
        // clearInterval(this.interval);
    }

    renderBody() {
        i = 0;
        let { getPreauthWorklist } = networkList;
        let { page_data_count, search_key, doctor_id, department_name ,pre_auth_submits,insurance_status,fc_payer_type,hims_payer_type} = this.state;
        this.setState((state) => ({ loadding: true, download_btn: true, downloadStatus: 0 }));
        let This = this;
        try {
            let userData = localStorage.getItem('user_data');
            if (userData !== undefined && userData !== null && userData !== '') {
                userData = JSON.parse(userData);
            }
            postService(getPreauthWorklist, 'POST', {
                'data': {
                    "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                    'page_no': page_data_count,
                    'page_number': page_data_count,
                    'page_data_count': page_data_count,
                    "search_key": search_key,
                    "doctor_id": doctor_id ? doctor_id : [],
                    "department_name": department_name ? department_name : [],
                    "preauth_submitted":pre_auth_submits?pre_auth_submits:[],
                    "insurance_status":insurance_status?insurance_status:[],
                    "fc_payertype":fc_payer_type?fc_payer_type:[],
                    "hims_payertype":hims_payer_type?hims_payer_type:[],
                    "from": This.state.dateFrom ? moment(this.state.dateFrom).format('YYYY-MM-DD') : '',
                    "to": This.state.dateTo ? moment(this.state.dateTo).format('YYYY-MM-DD') : '',
                    "export": 0, //1 for download excel
                }
            }).then(res => {
                this.setState((state) => ({ loadding: false }));
                if (res.status) {
                    if (res.data && Array.isArray(res['data']) && res['data'].length !== 0) {
                        this.setState((state) => ({ 'tbody': res['data'], 'total_items': res['total_count'], loadding: false }))
                        // enable downloadbtn after 2sec
                        // setTimeout(function () {
                        //     This.setState((state) => ({ downloadStatus: 1 }))
                        // }, 2000);
                    } else {
                        this.setState((state) => ({ 'tbody': [], 'total_items': 0 }))

                    }
                } else {
                    if (res === 401) {

                    } else {
                        Modal.error({
                            title: 'Failure',
                            content: "Oops! something went wrong... Please try again.",
                        });
                    }

                }
            })


        } catch (error) {
            this.setState((state) => ({ loadding: false }));
        }
    }

    navigateTo(body) {
        try {
        let { umr, unit_id } = body
        this.props.history.push(`/patients-history?umr=${umr}&unit_id=${unit_id}`);
    } catch (error) {
        console.log(error);
        this.setState((state) => ({ 'loadding': false }));
        Modal.error({
            title: 'Error Message',
            content: 'Oops, Something is wrong. Please try again.',
        })
    }

    }



    pageChange(data) {
        this.setState((state) => ({ 'page_data_count': data }), () => {
            this.renderBody();
        })
    }

    // searchClick() {
    //     i = 0;
    //     this.setState((state) => ({ 'page_data_count': 1, dateTo: moment().format('YYYY-MM-DD'), dateFrom: moment().subtract(15, 'd').format('YYYY-MM-DD') }), () => {
    //         this.renderBody();
    //     })
    // }

    searchClick() {
        try {
            let { getPreauthWorklist } = networkList;
            let userData = localStorage.getItem('user_data');
            if (userData !== undefined && userData !== null && userData !== '') {
                userData = JSON.parse(userData);
            }
        let { page_data_count, search_key, doctor_id, department_name ,pre_auth_submits,insurance_status,fc_payer_type,hims_payer_type} = this.state;
            postService(getPreauthWorklist, 'POST', {
                'data': {
                    "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                    'page_no': 1,
                    'page_number': 1,
                    'page_data_count': 1,
                    "search_key": search_key,
                    "doctor_id": doctor_id ? doctor_id : [],
                    "department_name": department_name ? department_name : [],
                    "preauth_submitted":pre_auth_submits?pre_auth_submits:[],
                    "insurance_status":insurance_status?insurance_status:[],
                    "fc_payertype":fc_payer_type?fc_payer_type:[],
                    "hims_payertype":hims_payer_type?hims_payer_type:[],
                    "from": '',
                    "to": '',
                    "export": 0, //1 for download excel
                }
            }).then(res => {
                this.setState((state) => ({ loadding: false }));
                if (res.status) {
                    if (res.data && Array.isArray(res['data']) && res['data'].length !== 0) {
                        this.setState((state) => ({ 'tbody': res['data'], 'total_items': res['total_count'], loadding: false }))
                        // enable downloadbtn after 2sec
                        // setTimeout(function () {
                        //     This.setState((state) => ({ downloadStatus: 1 }))
                        // }, 2000);
                    } else {
                        this.setState((state) => ({ 'tbody': [], 'total_items': 0 }))

                    }
                } else {
                    if (res === 401) {

                    } else {
                        Modal.error({
                            title: 'Failure',
                            content: "Oops! something went wrong... Please try again.",
                        });
                    }

                }
            })


        this.setState((state) => ({
            activePage: 1,
            tbody: [],
            totalItemsCount: 0,
            doctor_id: [],
            department_name: []
        }), () => {
            var formFeilds = this.state.formData;
            formFeilds.map((feild, key) => {
                if (feild.name === 'doctorid') {
                    formFeilds[key]['value'] = [];
                    formFeilds[key]['valid'] = false;
                    formFeilds[key]['errors'] = [];
                    formFeilds[key]['text'] = 'Doctor';
                } else if (feild.name === 'pendingDocs_departmentbyunit') {
                    formFeilds[key]['value'] = [];
                    formFeilds[key]['valid'] = false;
                    formFeilds[key]['errors'] = [];
                    formFeilds[key]['text'] = 'Department';
                }
                else if (feild.name === 'pre_auth_submitted') {
                    formFeilds[key]['value'] = null;
                    formFeilds[key]['valid'] = false;
                    formFeilds[key]['errors'] = [];
                    formFeilds[key]['text'] = 'Pre-Auth Submitted';
                }
                else if (feild.name === 'insurance_status') {
                    formFeilds[key]['value'] = null;
                    formFeilds[key]['valid'] = false;
                    formFeilds[key]['errors'] = [];
                    formFeilds[key]['text'] = 'Insurance Status';
                } else {
                    formFeilds[key]['value'] = [];
                    formFeilds[key]['valid'] = false;
                    formFeilds[key]['errors'] = [];
                    delete formFeilds[key]['text'];
                }
            })
            this.setState({ formData: formFeilds })
        })
    } catch (error) {
        console.log(error);
        this.setState((state) => ({ 'loadding': false }));
        Modal.error({
            title: 'Error Message',
            content: 'Oops, Something is wrong. Please try again.',
        })
    }
    }


    searchChange(e) {
        try {
        console.log(e.target.value);
        let value = e.target.value
        i = 0;
        this.setState((state) => ({
            'search_key': value
        })
        );
    } catch (error) {
        console.log(error);
        this.setState((state) => ({ 'loadding': false }));
        Modal.error({
            title: 'Error Message',
            content: 'Oops, Something is wrong. Please try again.',
        })
    }
    }

    itemRender(current, type, originalElement) {
        if (type === 'prev') {
            return <a>Previous</a>;
        }
        if (type === 'next') {
            return <a>Next</a>;
        }
        return originalElement;
    }

    indexIncrement() {
        i = i + 1;
    }
    dateRange = () => {
        this.setState((state) => ({
            activePage: 1,
            totalItemsCount: 0,
            page_data_count: 1,
            search_key: ''
        }), () => {
            this.inputRef.value = null;
            this.renderBody(true);
        })
    }

    downloadFile = () => {
        try {
            let This = this;
            let userData = localStorage.getItem('user_data');
            let { activePage, doctor_id, department_name, page_data_count,search_key,pre_auth_submits,insurance_status,fc_payer_type,hims_payer_type } = this.state;
            if (userData !== undefined && userData !== null && userData !== '') {
                userData = JSON.parse(userData);
            }
            const { getPreauthWorklist } = networkList;
            let tableHead = [];
             tableHead = [{
                'key': 'ip_no',
                'label': 'IP number'
            }, {
                'key': 'umr_no',
                'label': 'UMR number'
            }, {
                'key': 'patient_name',
                'label': 'Patient Name'
            }, {
                'key': 'phone_number',
                'label': 'Phone Number'
            }, {
                'key': 'date_of_counselling',
                'label': 'date of counselling'
            }, {
                'key': 'doctor_name',
                'label': 'Doctor Name'
            }, {
                'key': 'department_name',
                'label': 'Department Name'
            }, {
                'key': 'unit_name',
                'label': 'Unit Name'
            },
            {
                'key': 'rn_preauth_submitted',
                'label': 'Pre-auth Submitted'
            },
            {
                'key': 'payer_reponse_remarks',
                'label': 'Insurance Status'
            },
            {
                'key': 'fc_payer_type',
                'label': 'FC Payer Type'
            },
            {
                'key': 'hims_payer_type',
                'label': 'HIMS Payer Type'
            },
            {
                'key': 'rn_preauth_requested_time',
                // 'text': 'Preauth Submission Date'
                'label': 'Pre-Auth Triggered Time'
            },
            {
                'key': 'rn_preauth_submitted_date',
                'label': 'Pre-Auth Requested Time'
            }, {
                'key': 'payer_updated_at',
                'label': 'Preauth Response Received Date'
            },
            {
                'key': 'payer_approved_amount',
                'label': 'Approved Amount(Rs.)'
            },
            {
                'key': 'remedinet_remarks',
                'label': 'Remedinet Remarks'
            },
            // {
            //     'key': 'approval_file_content',
            //     'label': 'Document received from Remedinet'
            // },
            {
                'key': 'approval_file_name',
                'label': 'Document received from Remedinet'
            },
            {
                'key': 'action',
                'text': 'Action'
            }
    
            ];
            
            This.setState((state) => ({ downloadStatus: 0, thead: tableHead, loadding: true, filename: 'Pre-Auth Worklist.csv' }), () => {
                let userData = localStorage.getItem('user_data');
            if (userData !== undefined && userData !== null && userData !== '') {
                userData = JSON.parse(userData);
            }
            postService(getPreauthWorklist, 'POST', {
                'data': {
                    "unit_id": userData ? userData['unitid'] ? userData['unitid'] : null : null,
                    'page_no': page_data_count,
                    'page_number': page_data_count,
                    'page_data_count': page_data_count,
                    "search_key": search_key,
                    "doctor_id": doctor_id ? doctor_id : [],
                    "department_name": department_name ? department_name : [],
                    "preauth_submitted":pre_auth_submits?pre_auth_submits:[],
                    "insurance_status":insurance_status?insurance_status:[],
                    "fc_payertype":fc_payer_type?fc_payer_type:[],
                    "hims_payertype":hims_payer_type?hims_payer_type:[],
                    "from": This.state.dateFrom ? moment(this.state.dateFrom).format('YYYY-MM-DD') : '',
                    "to": This.state.dateTo ? moment(this.state.dateTo).format('YYYY-MM-DD') : '',
                    "export": 1, //1 for download excel
                }
                }).then(res => {
                    console.log('tat report:', res);
                    // console.log('data res:', data)
                    if (res.status) {
                        res.data.map((data, key) => {
                            Object.keys(data).map((dataKey) => {
                                // if (dataKey === 'admission_date') {
                                //     res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD-MM-YYYY HH:mm').toString() : 'NA'
                                // }
                                // if (dataKey === 'latest_counselled_date') {
                                //     res.data[key][dataKey] = res.data[key][dataKey] ? moment(res.data[key][dataKey]).format('DD-MM-YYYY HH:mm') : 'NA'
                                // }
                                // else {
                                res.data[key][dataKey] = res.data[key][dataKey] ? res.data[key][dataKey] : 'NA'
                                // }

                            })
                        })
                        This.setState((state) => ({ downloadtbody: res.data, loadding: false, downloadStatus: 1 }));
                        this.csvLink.current.link.click();
                    } else {
                        if (res === 401) {

                        } else {
                            Modal.error({
                                title: 'Failure',
                                content: "Oops! something went wrong... Please try again.",
                            });
                        }
                    }
                });
            });
        } catch (error) {
            console.log(error);
        }
    }
    clearFilter = () => {
        try {
        this.setState(() => ({ doctor_id: '', department_name: '', search_key: '', activePage: 1, totalItemsCount: 0 , pre_auth_submits:'',
        insurance_status:'',
        fc_payer_type:'',
        hims_payer_type:''}),
            () => {
                this.inputRef.value = null;
                var formFeilds = this.state.formData;
                formFeilds.map((feild, key) => {
                    if (feild.name === 'doctorid') {
                        formFeilds[key]['value'] = [];
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        formFeilds[key]['text'] = 'Doctor';
                    } else if (feild.name === 'pendingDocs_departmentbyunit') {
                        formFeilds[key]['value'] = [];
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        formFeilds[key]['text'] = 'Department';
                    }else if (feild.name === 'pre_auth_submitted') {
                        formFeilds[key]['value'] = null;
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        formFeilds[key]['text'] = 'Pre-Auth Submitted';
                    }
                    else if (feild.name === 'insurance_status') {
                        formFeilds[key]['value'] = null;
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        formFeilds[key]['text'] = 'Insurance Status';
                    }
                     else {
                        formFeilds[key]['value'] = null;
                        formFeilds[key]['valid'] = false;
                        formFeilds[key]['errors'] = [];
                        delete formFeilds[key]['text'];
                    }
                })
                this.setState({ formData: formFeilds })
                this.renderBody();
            })
        } catch (error) {
            console.log(error);
            this.setState((state) => ({ 'loadding': false }));
            Modal.error({
                title: 'Error Message',
                content: 'Oops, Something is wrong. Please try again.',
            })
        }

    }

    openupload = (data) => {
        try {
        let { unit_id, umr_no, ip_no, counsellng_id, patient_name, date_of_counselling } = data
        let { resData } = this.state
        let sendData = {
            'unit_id': unit_id,
            'umr_no': umr_no,
            'ip_no': ip_no,
            'patient_name': patient_name,
            'temp': Math.floor(Math.random() * 100),
            'counselling_id': counsellng_id,
            'date_of_counselling': date_of_counselling
        }
        this.setState(() => ({ 'mydata': sendData }), () => { this.child.setModal1Visible(true) });
    } catch (error) {
        console.log(error);
        this.setState((state) => ({ 'loadding': false }));
        Modal.error({
            title: 'Error Message',
            content: 'Oops, Something is wrong. Please try again.',
        })

    }

    }
    // handleChange(ele) {
    //     let { preauthSchema } = this.state;
    //     if (ele.name === 'payer') {
    //         preauthSchema.map((item) => {
    //             if (item.name === ele.name) {
    //                 localStorage.setItem('payercode', item.value);
    //             }
    //             if (item.name === 'zone') {
    //                 item.text = null;
    //                 item.value = null;
    //                 item.disable = false;
    //             }
    //             if (item.name === 'insurance_company_name') {
    //                 item.disable = false;
    //                 item.text = null;
    //                 item.value = null;
    //             }
    //         })
    //     }

    //     this.setState({ preauthSchema: preauthSchema });
    // }
    submit() {
        try {
        var formFeilds = this.state.formData;
        let { search } = this.state
        this.setState(({ doctor_id: formFeilds[1].value, department_name: formFeilds[2].value, search_key: '', activePage: 1, pre_auth_submits:formFeilds[3].value,
        insurance_status:formFeilds[4].value,
        fc_payer_type:formFeilds[5].value,
        hims_payer_type:formFeilds[6].value}), () => {
            this.inputRef.value = null;
            this.renderBody()
        })
    } catch (error) {
        console.log(error);
        this.setState((state) => ({ 'loadding': false }));
        Modal.error({
            title: 'Error Message',
            content: 'Oops, Something is wrong. Please try again.',
        })

    }
    }
    modelVisisablePreAuthSubmit(data) {
        this.setState({loadding: true});
        let { preauthFileSchema } = this.state;

        let { getUploadPatientsDocumentsDetails,getPatientDocumentDetails, getRemedinetPayerlist, getRemedinetZoneslist, getRemedinetInsurancesCompanyList } = networkList;
        let payload = {
            counselling_id: data.counsellng_id,
            form_type: "view",
            ip_no: data.ip_no,
            umr_no: data.umr_no,
            unit_id: data.unit_id
        }

        const patient_name = data.patient_name;
        const umr_no = data.umr_no;
        const ip_no = data.ip_no
        let payerText, zoneText, insurance_company_text;
        
        if (data.tpacode !== null && data.tpacode !== '' && data.tpacode !== undefined) {
            postService(getRemedinetPayerlist, 'POST', {
                "data": { "unit_id": data.unit_id ? data.unit_id : '' }
            }).then(res => {
                const payer = res['data']
                if (payer) {
                    payerText = payer.find(x => x.id === data.tpacode)
                }
            });

        }
        if (data.zone_id !== null && data.zone_id !== '' && data.zone_id !== undefined) {
            postService(getRemedinetZoneslist, 'POST', {
                "data": { "unit_id": data.unit_id ? data.unit_id : '', "payercode": data.tpacode ? data.tpacode : '' }
            }).then(res => {
                const zone = res['data']
                if (zone) {
                    zoneText = zone.find(x => x.id === data.zone_id);
                }
            });
        }
        if (data.insurance_company_id !== null && data.insurance_company_id !== '' && data.insurance_company_id !== undefined) {
            postService(getRemedinetInsurancesCompanyList, 'POST', {
                "data": { "unit_id": data.unit_id ? data.unit_id : '', "payercode": data.tpacode ? data.tpacode : '' }
            }).then(res => {
                const insurance_company = res['data']
                if (insurance_company) {
                    insurance_company_text = insurance_company.find(x => x.id === data.insurance_company_id)
                }
            });
        }
        let preAuthFile = [
            {
                'key': 's_no',
                'text': '#'
            },
            {
                'key': 'document_url',
                'text': 'Document  Name',
            }
        ];
        preauthFileSchema.map((subTable, key) => {
            let table_body = subTable.Specification.table_body;
            table_body.map((feild, table_key) => {
                if (table_body.length > 0) {
                    // if (table_key === 0) {
                    //     let row = feild.feilds;
                    //     row.map((sub_feild, sub_table_key) => {
                    //         if (sub_feild.name === "file_access") {
                    //             preauthFileSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                    //             preauthFileSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                    //             preauthFileSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['file_upload_id'] =null
                    //         }
                    //         if (sub_feild.name === 'document_name') {
                    //             preauthFileSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                    //             preauthFileSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                    //             preauthFileSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['patient_name']=null
                    //             preauthFileSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['umr_no']=null
                    //             preauthFileSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['ip_no']=null
                    //         }
                    //         // if (sub_feild.name === "is_rn_file_uploaded") {
                    //         //     preauthFileSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                    //         //     preauthFileSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                    //         // }
                    //         // if (sub_feild.name === "rn_uploaded_time") {
                    //         //     preauthFileSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['value'] = null;
                    //         //     preauthFileSchema[key].Specification.table_body[table_key].feilds[sub_table_key]['text'] = null;
                    //         // }
                           
                    //     })
                    // } else {
                        preauthFileSchema[key].Specification.table_body.splice(1, table_body.length-1)
                    // }

                    // }
                }
            })
        })
        console.log(preauthFileSchema)
        try {
            const Userlogobj = {
                "data": {
                    "user": JSON.parse(localStorage.getItem('user')),
                    "action": "get Patient Document Details - Request",
                    "date": new Date(),
                    "meta": payload
                }
            }
            userTrackService(Userlogobj);
            postService(getUploadPatientsDocumentsDetails, 'POST', { "data": payload }).then(res => {
                const Userlogobjres = {
                    "data": {
                        "user": JSON.parse(localStorage.getItem('user')),
                        "action": "get Patient Document Details - Response",
                        "date": new Date(),
                        "meta": res
                    }
                }
                userTrackService(Userlogobjres);
                if (res['status']) {
                    let latest_cou_id = res['latest_counselling_id'] ? res['latest_counselling_id'] : null
                    this.setState((state) => ({ 'patientDocument': res['data'], 'latest_counselling_id': latest_cou_id, preAuthFile: preAuthFile, patient_name: data.patient_name, umr_no: data.umr_no, ip_no: data.ip_no }));
                    this.setState({ loadding: false })
                    if (res['data'].length > 0) {
                        if (res['data'].some(item => item.is_uploaded === '1')) {
                            let { preauthSchema } = this.state;
                            preauthSchema.map((item) => {
                                if (item.name === "payer") {
                                    if (data.tpacode !== null && data.tpacode !== '' && data.tpacode !== undefined) {
                                        item.text = payerText ? payerText.name : null;
                                        item.value = data.tpacode ? data.tpacode : null;
                                    } else {
                                        item.text = 'Select Payer';
                                        item.value = null;
                                        item.errors =[];
                                    }
                                }
                                if (item.name === 'zone') {
                                    if (data.zone_id !== null && data.zone_id !== '' && data.zone_id !== undefined) {
                                        item.text = zoneText ? zoneText.name : '';
                                        item.value = data.zone_id ? data.zone_id : '';
                                        item.disable = false;
                                         //item.disable = data.zone_id ? false : true;
                                    } else {
                                        item.text = 'Select Zone';
                                        item.value = null;
                                        item.disable = false;
                                        //item.disable = true;
                                    }
                                }
                                if (item.name === 'insurance_company_name') {
                                    if (data.insurance_company_id !== null && data.insurance_company_id !== '' && data.insurance_company_id !== undefined) {
                                        item.disable = false;
                                        item.text = insurance_company_text ? insurance_company_text.name : '';
                                        item.value = data.insurance_company_id ? data.insurance_company_id : '';
                                    } else {
                                        item.disable = false;
                                        // item.disable = true;
                                        item.text = 'Select Insurance Company';
                                        item.value = null;
                                    }
                                }
                            });
                          
                            if (res['data'].length > 0) {
                                preauthFileSchema.map((subTable, key) => {
                                    let table_body = subTable.Specification.table_body;
                                    table_body.map((feild, table_key) => {
                                        if (table_body.length > 0) {
                                                preauthFileSchema[key].Specification.table_body.length=0;
                                         
                                        }
                                    })
                                })
                                preauthFileSchema.map((data, secKey) => {
                                    preauthFileSchema[secKey].visible = true;
                                    res['data'][0].document_url.map((file, file_key) => {
                                        if(file['document_url']){
                                            let last_element = preauthFileSchema[secKey].Specification.table_body[preauthFileSchema[secKey].Specification.table_body.length - 1];
                                            

                                            let obj = {
                                                "feilds": (data['Specification'] && data['Specification']['add_more_feilds']) ? JSON.parse(JSON.stringify(data['Specification']['add_more_feilds'])) : [],
                                                id: file_key+1,
                                                input_feild: [],
                                                text: "Highend",
                                                'key_word': 'add_more',
                                                type: "text"
                                            }
                                            obj['feilds'].map((feild, key) => {
                                                obj['feilds'][key]['id'] = null;
                                                obj['feilds'][key]['value'] = null;
                                                obj['feilds'][key]['text'] = null;
                                            })
                                            obj['feilds'].map((feild, key) => {
                                                obj['feilds'][key]['id'] = file_key + 1;
                                                if (feild.name === "file_access") {
                                                    obj['feilds'][key]['value'] = file['is_uploaded'] ? true : false
                                                    obj['feilds'][key]['file_upload_id'] =file['file_uploading_id']

                                                }
                                                if (feild.name === "document_name") {
                                                    obj['feilds'][key]['value'] = file['document_url'];
                                                    obj['feilds'][key]['text'] = file['document_url'];
                                                    obj['feilds'][key]['patient_name'] = patient_name
                                                    obj['feilds'][key]['umr_no'] = umr_no
                                                    obj['feilds'][key]['ip_no'] = ip_no

                                                }
                                                // if (feild.name === "is_rn_file_uploaded") {
                                                //     obj['feilds'][key]['value'] = file['is_rn_file_uploaded'] ? 'YES' : "NO"
                                                //     obj['feilds'][key]['text'] =file['is_rn_file_uploaded'] ? 'YES' : "NO"

                                                // }
                                                // if (feild.name === "rn_uploaded_time") {
                                                //     obj['feilds'][key]['value'] = file['rn_uploaded_time'] ?  moment(file['rn_uploaded_time']).format('DD-MM-YYYY HH:mm')  : "--"
                                                //     obj['feilds'][key]['text'] =file['rn_uploaded_time'] ?  moment(file['rn_uploaded_time']).format('DD-MM-YYYY HH:mm')  : "--"

                                                // }

                                            })
                                            data['Specification']['table_body'].push(obj);
                                        }
                                    }
                                    // }

                                    )

                                });
                            }
                            console.log(preauthFileSchema)
                           
                            this.setState({
                                commentModal: true, preauthSchema: JSON.parse(JSON.stringify(preauthSchema)), preauthdata: data, preAuthFile: preAuthFile, preauthFileSchema: preauthFileSchema
                            });
                        } else {
                            Modal.error({
                                title: 'Error Message',
                                content: 'Please upload atleast one document before submitting the Pre-auth.',
                            })
                        }
                    } else {
                        Modal.error({
                            title: 'Error Message',
                            content: 'Please upload atleast one document before submitting the Pre-auth.',
                        })
                    }

                } else {
                    this.setState((state) => ({ 'patientDocument': [] }));
                    this.setState({ loadding: false })
                }
            });
        } catch (error) {
            console.log(error);
            this.setState((state) => ({ 'loadding': false }));
            Modal.error({
                title: 'Error Message',
                content: 'Oops, Something is wrong. Please try again.',
            })

        }


    }
    historyPreAuth(data) {
        let thead = [
            {
                'key': 'historyid',
                'text': 'History ID'
            },
            {
                'key': 'preauth_actionstatus',
                'text': 'pre-Auth Requested' 
            },
            {
                'key': 'preauth_submited_time',
                'text': 'Pre-Auth Triggered Time' 
            },
            //  {
            //     'key': 'preauth_submited_time',
            //     'text': 'Pre-Auth Requested Time' 
            // },
            {
                'key': 'payer_status',
                'text': 'Payer Status'
            },
            {
                'key': 'payer_updated_time',
                'text': 'Payer Updated Time'
            }, {
                'key': 'approvedamount',
                'text': 'Approved amount'
            }, {
                'key': 'approveddate',
                'text': 'Approved Time'
            }, {
                'key': 'remedinet_remarks',
                'text': 'Remedinet Remarks'
            }

        ];
        let { getRemedinetPayerHistory } = networkList;
        if (data.rn_reference_number) {
            postService(getRemedinetPayerHistory, 'POST', {
                "data": { "unit_id": data.unit_id ? data.unit_id : '', "refNo": data.rn_reference_number ? data.rn_reference_number : '' }
            }).then(res => {
                if (res.status) {
                    this.setState({ viewHistory: true, patientHistory: res.data, thead: thead, patient_name: data.patient_name, umr_no: data.umr_no, ip_no: data.ip_no })
                }
                else {
                    this.setState({ viewHistory: true, patientHistory: res.data, thead: thead, patient_name: data.patient_name, umr_no: data.umr_no, ip_no: data.ip_no })
                }

            });
        }

    }
    // modelVisisableViewpdf(ele) {
    //     this.setState({ viewpdf: true, ViewURLPDF: ele })

    // }
    modelVisisableViewpdf = (url) => {
        this.setState({ viewpdf: true, ViewURLPDF: url });
      };
    PDFModelClose() {
        this.setState({ viewpdf: false })
    }
    submitPreAuth(data) {
        let selected_files=[];
        let { preauthSchema ,preauthFileSchema} = this.state;
        let { submitPreauth } = networkList;
        let error = this.validateModalFeilds(preauthSchema);
        let tpacode, tpaname, zone_id, zone_val, insurance_val, insurance_id;
        preauthSchema.map((item) => {
            if (item.name === "payer") {
                tpaname = item.text ? item.text : '';
                tpacode = item.value ? item.value : '';
            }
            if (item.name === 'zone') {
                zone_val = item.value?item.text ? item.text : '':'';
                zone_id = item.value ? item.value : '';
            }
            if (item.name === 'insurance_company_name') {
                insurance_val = item.value?item.text ? item.text : '':'';
                insurance_id = item.value ? item.value : '';
            }
        });
        preauthFileSchema.map((data, secKey) => {
            data['Specification']['table_body'].map((table_body, table_key) => {
                table_body['feilds'].map((feilds, key) => {
                    if (feilds.name === "file_access" && feilds.value) { 
                        selected_files.push(feilds['file_upload_id'])
                    }
                });
            })
        })
        console.log('SELECTED FILES',selected_files)
        let user_data = ''
        if (localStorage.getItem('user_data') !== null && localStorage.getItem('user_data') !== undefined && localStorage.getItem('user_data') !== '') {
            user_data = JSON.parse(localStorage.getItem('user_data'));
        }
        console.log('SELECTED FILES11',user_data)
        if (!error.includes(false) && data !== 0 && data !== null && data !== undefined && data !== '') {
            this.setState({ commentModal: false, loadding: true });
            let payload = {
                "tpacode": tpacode,
                "tpaname": tpaname,
                "hospitalcode": data.unit_id ? data.unit_id : '',
                "unit_id": data.unit_id ? data.unit_id : '',
                "zone_id": zone_id,
                "zone_val": zone_val,
                "employeeid": "",
                "insurance_val": insurance_val,
                "insurance_id": insurance_id,
                "policyno": "",
                "patientfirstname": data.patient_name ?data.patient_name.replace(/[&\/\\#, +()$~%.'":*?<>{}]/g, ' '):'',
                "patientmiddlename": '',
                "patientlastname": "",
                "gender_val": "",
                "address": "",
                "mobileno": data.phone_number ? data.phone_number : '',
                "relationship_val": "Self",
                "relationship_id": "",
                "doa": data.admission_date ? data.admission_date : '',
                "doa_time": '',
                "dod": data.discharge_date ? data.discharge_date : '',
                "dod_time": '',
                "durationofstay": '',
                "ipnumber": data.ip_no ? data.ip_no : '',
                "umrnumber": data.umr_no ? data.umr_no : '',
                "counselling_id": data.counsellng_id,
                "e_date_of_admission": data.e_date_of_admission ? data.e_date_of_admission : '',
                "previous_payer_responce": data.payer_response ? data.payer_response : '',
                'previous_rn_reference_number': data.rn_reference_number ? data.rn_reference_number : '',
                'previous_rn_history_id': data.rn_history_id ? data.rn_history_id : '',
                'selected_files':selected_files ? selected_files:'',
                'fk_admission_id':data.fk_admission_id
            }
            try {
                postService('submitPreauth1', 'POST', {
                    'data':
                         payload

                }).then(res => {
                    if (res.status) {
                        preauthSchema.map((item) => {
                            if (item.name === "payer") {
                                item.text = null;
                                item.value = null;
                            }
                            if (item.name === 'zone') {
                                item.text = null;
                                item.value = null;
                                item.disable = false;
                                //item.disable = true;
                            }
                            if (item.name === 'insurance_company_name') {
                                item.disable = false;
                                //item.disable = true;
                                item.text = null;
                                item.value = null;
                            }
                        });
                        setTimeout(() => { this.setState({ preauthSchema: preauthSchema, preauthdata: [] }) }, 1000)
                        this.setState({
                            loadding: false,
                            preauthSchema: preauthSchema
                        })
                        this.renderBody();
                        Modal.success({
                            title: 'Success message',
                            content: res.message ? res.message : 'consent Added Successfully',
                        }
                        );
                    } else {
                        this.setState({ commentModal: false });
                        preauthSchema.map((item) => {
                            if (item.name === "payer") {
                                item.text = null;
                                item.value = null;
                            }
                            if (item.name === 'zone') {
                                item.text = null;
                                item.value = null;
                                item.disable = false;
                                //item.disable = true;
                            }
                            if (item.name === 'insurance_company_name') {
                                item.disable = false;
                                // item.disable = true;
                                item.text = null;
                                item.value = null;
                            }
                        });
                        setTimeout(() => { this.setState({ preauthSchema: preauthSchema }) }, 1000)
                        this.setState({
                            loadding: false,
                            preauthSchema: preauthSchema
                        })
                        Modal.error({
                            title: 'Failure',
                            content: res.message ? res.message : 'Oops! something is wrong. Please try again.',
                        })
                    }
                })
            } catch (error) {
                console.log(error);
                this.setState((state) => ({ loadding: false }));

                Modal.error({
                    title: 'Failure',
                    content: 'Oops, something is wrong. Please try again.',
                })

            }
        }
    }
    validateModalFeilds(formFeilds) {

        let errors = [];
        let role_id = null;
        formFeilds.map((feild, key) => {
            if ((feild['element'] === 'select2')) {
                formFeilds[key]['errors'] = [];
                if (!feild.disable && feild.visible) {
                    feild
                        .rules
                        .map((rule, rkey) => {
                            if ((feild['value'] === null) || feild['value'] === '' || (feild['value'] === undefined)) {

                                formFeilds[key]['errors'].push({ 'message': rule.message });
                                errors.push(false);
                            }
                            else {
                                console.log('no', feild['name'], feild['value'])
                                formFeilds[key]['errors'] = [];
                                errors.push(true);
                            }
                        })

                }
            }
        })

        this.setState((state) => ({ formFeilds: formFeilds }));
        return errors;
    }
    preAuthModelClose() {
        let { preauthSchema } = this.state;
        preauthSchema.map((item) => {
            if (item.name === "payer") {
                item.text = null;
                item.value = null;
            }
            if (item.name === 'zone') {
                item.text = null;
                item.value = null;
                item.disable = true;
            }
            if (item.name === 'insurance_company_name') {
                item.disable = true;
                item.text = null;
                item.value = null;
            }
        });

        this.setState({ preauthSchema: preauthSchema, commentModal: false });
    }
    viewHistoryModelClose() {
        this.setState({ viewHistory: false })
    }
    handleChange(body) {
        let { preauthFileSchema,preauthSchema } = this.state;
        preauthFileSchema.map((data, secKey) => {
            data['Specification']['table_body'].map((table_body, table_key) => {
                table_body['feilds'].map((feilds, key) => {
                    if (feilds.name === body.name && feilds.id === body.id) {
                        preauthFileSchema[secKey].Specification.table_body[table_key].feilds[key]['value'] = body.value;
                    }
                })
            })
        })
        if (body.name === 'payer') {
            preauthSchema.map((item) => {
                if (item.name === body.name) {
                    localStorage.setItem('payercode', item.value);
                }
                if (item.name === 'zone') {
                    item.text = null;
                    item.value = null;
                    item.disable = false;
                }
                if (item.name === 'insurance_company_name') {
                    item.disable = false;
                    item.text = null;
                    item.value = null;
                }
            })
        }

        this.setState({
            preauthFileSchema: preauthFileSchema,preauthSchema:preauthSchema
        })
    }
    deleteRow(data) {

    }
    render() {
        let { tbody, tableHead, previlege_data, total_items, page_data_count, page_length, download_btn, downloadStatus, filename, downloadtbody, downloadthead, activePage, formData, commentModal, preauthSchema, preauthdata, viewpdf, ViewURLPDF, viewHistory, patientHistory, thead, umr_no, ip_no, patient_name, preAuthFile, patientDocument, checked, preauthFileSchema } = this.state;
        return (
            <div>
                <div className="clearfix mx-5 mb-3">
                            
                <div className="float-left pt-2">
                Pre-Auth Worklist
                    </div>
                    <div className="float-left pt-2">
                    </div>
                    <div className="float-right download sticky-top d-flex flex-row-reverse">
                        {
                            (tbody && tbody.length !== 0)
                                ?
                                <div className="float-right mb-2 download sticky-top d-flex flex-row-reverse">
                                    <button className="btn btn-success text-capitalize" onClick={() => { this.downloadFile() }}><img src={homepage+"/assets/images/icons/download1.png"} alt="" className="pr-2" /> <span> Download Worklist</span></button>
                                <CSVLink data={downloadtbody} headers={thead} filename={filename} className="hidden" ref={this.csvLink} />
                                    <button className="btn btn-light text-capitalize py-1 mr-3" onClick={() => { this.clearFilter() }}><UndoOutlined className="align-middle pr-2" /><span> Clear</span></button>
                                    <button className="btn btn-success text-capitalize mr-3" onClick={() => { this.submit() }}><span>Submit</span></button>
                                </div>
                                :
                                <div className="float-right mb-2 download sticky-top d-flex flex-row-reverse">
                                    <Button className="btn btn-success-disabled text-capitalize" disabled><img src={homepage+"/assets/images/icons/download1.png"} alt="" className="pr-2" /><span> Download Worklist</span></Button>
                                    <button className="btn btn-light text-capitalize py-1 mr-3 " onClick={() => { this.clearFilter() }}><UndoOutlined type="reload" className="align-middle pr-2" /><span> Clear</span></button>
                                    <Button className="btn btn-success text-capitalize mr-3" onClick={() => { this.submit() }}><span>Submit</span></Button>
                                </div>
                        }
                    </div>
                </div>
                <div className="card mx-5 mb-5 card-table">
                    <div className="card-header bg8">
                        <div className="clearfix">
                            <div className=" row">
                                {(formData !== undefined) && <React.Fragment>

                                    {formData
                                        .map((feild, key) => {

                                            if (feild.element === 'input') {
                                                return (
                                                    <React.Fragment key={key}>
                                                        <div
                                                            className={`${feild.className
                                                                ? feild.className
                                                                : 'col '} ${feild.name}`}
                                                            key={key}>
                                                            <div className="input-group" key={key}>
                                                                {/* <input type="text" id="myInput" className="form-control form-control-sm" aria-label="Text input with dropdown button" placeholder="Patient Name or UMR or IP" /> */}
                                                                <div
                                                                    className='w-100'
                                                                    key={key}>
                                                                    <input type="text" id="myInput" class="form-control form-control-sm" aria-label="Text input with dropdown button" placeholder="Patient Name or UMR" onBlur={this.searchChange.bind(this)} ref={(inputRef => (this.inputRef = inputRef))} />
                                                                    <div class="input-group-append" style={{ position: 'absolute', right: 0, height: '32px', top: 0 }}>
                                                                        <button class="btn btn-primary btn-sm" type="button" onClick={this.searchClick.bind(this)}><img src={homepage+"/assets/images/icons/search.png"}></img></button>
                                                                    </div>
                                                                </div>
                                                                {/* <div className="input-group-append" style={{position: 'absolute', right: 0, height: '32px'}}>                                                                    
                            <button className="btn btn-primary btn-sm" onClick={this.search}><img src="/assets/images/icons/search.png" /></button>
                        </div> */}
                                                            </div>
                                                        </div>
                                                    </React.Fragment>
                                                )
                                            }
                                            if (feild.element === 'select2') {
                                                return (
                                                    <React.Fragment key={key}>
                                                        <div
                                                            className={`${feild.className
                                                                ? feild.className
                                                                : 'col '} ${feild.name}`}
                                                            key={key}>
                                                            {/* <p className="data-label text-white w-25 mb-1 pt-1 text-right pr-2">{feild.text2}</p> */}
                                                            <Select2
                                                                Queuedata={formData}
                                                                selectdata={feild}
                                                                {...this.props}
                                                                {...this.state}
                                                                onselectChanges={this
                                                                    .handleChange
                                                                    .bind(this)}
                                                            /> {feild
                                                                .errors
                                                                .map((error, eKey) => {
                                                                    return (
                                                                        <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                                    );
                                                                })}
                                                        </div>
                                                    </React.Fragment>
                                                )
                                            }
                                            if (feild.element === 'select2multiple' && feild.visible) {
                                                return (
                                                    <React.Fragment key={key}>
                                                        <div
                                                            className={`${feild.className
                                                                ? feild.className
                                                                : 'col '} ${feild.name}`}
                                                            key={key}>
                                                            <Select2multiple
                                                                Queuedata={formData}
                                                                selectdata={feild}
                                                                {...this.props}
                                                                {...this.state}
                                                                onselectChanges={this
                                                                    .handleChange
                                                                    .bind(this, feild)}
                                                            /> {feild
                                                                .errors
                                                                .map((error, eKey) => {
                                                                    return (
                                                                        <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                                    );
                                                                })}
                                                        </div>
                                                    </React.Fragment>
                                                )
                                            }
                                            if (feild.element === 'daterange') {
                                                return (
                                                    <div
                                                        className={`${feild.className
                                                            ? feild.className
                                                            : 'col '} ${feild.name}`}
                                                        key={key}>
                                                        {/* <p className="data-label text-white mb-1 pt-1 text-right pr-2">{feild.text}: </p> */}

                                                        <DateRange
                                                            Queuedata={formData}
                                                            selectdata={feild}
                                                            {...this.props}
                                                            {...this.state}
                                                            onselectChanges={(e) => { console.log('onselectChanges:', e.value[0]); this.setState({ dateFrom: e.value[0], dateTo: e.value[1] }) }}
                                                        />
                                                        <div class="input-group-append">
                                                            <button class="btn btn-primary btn-sm ml-1" onClick={this.dateRange}>Go</button>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        })}

                                </React.Fragment>}

                            </div>
                        </div>
                    </div>

                    <div className="financial-table table-responsive sticky-header" id="table">
                        <table className="table table-hover table-bordered mb-0 bg-white" style={{ width: '300%' }}>
                            <thead>
                                <tr>
                                    <td>S.no</td>
                                    {tableHead.map((head, key) => {
                                        return (<td key={key}>{head.text}</td>);
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                {tbody.map((body, key) => {
                                    return (<tr key={key}>
                                        {/* onClick={this.navigateTo.bind(this,body)} style={{cursor: 'pointer'}} */}
                                        <td>{(key + 1) + (page_data_count > 1 ? 20 * (page_data_count > 2 ? (page_data_count - 1) : 1) : 0)}</td>
                                        {tableHead.map((head, Hkey) => {

                                            if (head['key'] === 'date_of_counselling') {
                                                return (<td>{body[head['key']] ? moment(body[head['key']]).format('DD-MM-YYYY HH:mm') : '--'}</td>)
                                            }
                                            if (head['key'] === 'rn_preauth_submitted') {
                                                return (<td>{body[head['key']] ? body[head['key']] : 'NO'}</td>)
                                            }
                                            if (head['key'] === 'payer_reponse_remarks') {
                                                return (<td>{body[head['key']] ? body[head['key']] : '--'}</td>)
                                            }
                                            if (head['key'] === 'fc_payer_type') {
                                                return (<td>{body[head['key']] ? body[head['key']] : '--'}</td>)
                                            }
                                            if (head['key'] === 'hims_payer_type') {
                                                return (<td>{body[head['key']] ? body[head['key']] : '--'}</td>)
                                            }
                                            if (head['key'] === 'rn_preauth_requested_time') {
                                                return (<td>{body[head['key']] ? moment(body[head['key']]).format('DD-MM-YYYY HH:mm:ss') : '--'}</td>)
                                            }
                                            if (head['key'] === 'rn_preauth_submitted_date') {
                                                return (<td>{body[head['key']] ? moment(body[head['key']]).format('DD-MM-YYYY HH:mm:ss') : '--'}</td>)
                                            }
                                            if (head['key'] === 'payer_updated_at') {
                                                return (<td>{body[head['key']] ? moment(body[head['key']]).format('DD-MM-YYYY HH:mm:ss') : '--'}</td>)
                                            }
                                            if (head['key'] === 'payer_approved_amount') {
                                                return (<td>{body[head['key']] ? body[head['key']] : '--'}</td>)
                                            }
                                            if (head['key'] === 'remedinet_remarks') {
                                                return (<td>{body[head['key']] ? body[head['key']] : '--'}</td>)
                                            }
                                            if (head['key'] === 'approval_file_name') {
                                                if ((body['approval_file_name']) !== '' && (body['approval_file_name']) !== undefined && (body['approval_file_name']) !== null) {
                                                    return (
                                                    <td>
                                                        <a
                                                            href={`${UPLOAD_URL}${body['approval_file_name']}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                        >
                                                            Open Document
                                                        </a>
                                                        {/* <FileDoneOutlined style={{ fontSize: '54px' }} onClick={this.modelVisisableViewpdf.bind(this, filePath)} /> */}
                                                         </td>
                                                )
                                                } else {
                                                    return (
                                                    <td>--</td>);
                                                }

                                            }
                                            if (head['key'] === 'action') {
                                                return (<td>
                                                    <Tooltip title="Upload Documents"><img src={homepage+"/assets/images/upload.png"} alt="edit" style={{ marginTop: '5px' }} onClick={() => { this.openupload(body) }} /></Tooltip>
                                                    {/* <Counselling_upload {...this.props} {...this.state} ref={instance => { this.child = instance; }} /> */}
                                                    <New_Counselling_upload {...this.props} {...this.state} ref={instance => { this.child = instance; }} />
                                                    <Tooltip title="Pre-auth Submit"><SendOutlined className="p-2 border bg-success ml-1 text-white " style={{ verticalAlign: '-webkit-baseline-middle' }}
                                                        onClick={this.modelVisisablePreAuthSubmit.bind(this, body)}
                                                    /></Tooltip>
                                                    <Tooltip title={body['rn_reference_number'] ? "View History" : "No History"}><HistoryOutlined className="p-2 border  ml-1 text-white history_icon " style={{ verticalAlign: '-webkit-baseline-middle' }} onClick={body['rn_reference_number'] ? this.historyPreAuth.bind(this, body) : ''} /></Tooltip>
                                                </td>)
                                            }
                                            return (
                                                <td className="text-capitalize">
                                                    {(body[head['key']] !== null) ? body[head['key']] : 'NA'}
                                                </td>
                                            )

                                        })
                                        }

                                    </tr>)
                                })}
                                {(tbody && tbody.length === 0) && <React.Fragment>

                                    <tr>
                                        <td colSpan={tableHead.length + 1} className="text-center">
                                            <img src={homepage+"/assets/images/icons/no-data.svg"} alt="" />
                                            <p className="no-data mb-0">No Data</p>
                                        </td>
                                    </tr>

                                </React.Fragment>}
                            </tbody>
                        </table>
                    </div>
                </div>
                {(this.state.loadding) && <div className="loadding"> <Spin tip="Loading..." size={'large'}></Spin></div>}
                <div className="col-6 offset-3 text-center mb-5 pb-5">
                    <Pagination current={page_data_count} total={total_items} itemRender={this.itemRender.bind(this)} pageSize={page_length} showSizeChanger={false} onChange={this.pageChange.bind(this)} />
                </div>
                <Modal
                    title=''
                    centere
                    footer={null}
                    width='95%'
                    height='95%'
                    zIndex='1021'
                    closable={false}
                    maskClosable={false}
                    destroyOnClose={true}
                    visible={commentModal}>
                    <Spin spinning={this.state.loadding} >
                        {commentModal &&
                            <React.Fragment>
                                <Tooltip title="Close"><CloseOutlined type="close" className="comments-popup-close" onClick={() => this.preAuthModelClose()} /></Tooltip>
                                <h4 className="text-center">Pre-Authorisation</h4>
                                <div className="row pb-3 pt-3">
                                    <div className="col-6 my-auto">
                                        <h6 className="mb-0"> <Tooltip title="Patient Name">{patient_name ? patient_name : '--'}</Tooltip></h6>
                                    </div>
                                    <div className="col-2 my-auto">
                                        <h6 className="mb-0"> <Tooltip title="UMR Number">{umr_no ? umr_no : '--'}</Tooltip></h6>
                                    </div>
                                    <div className="col-2 my-auto">
                                        <h6 className="mb-0"> <Tooltip title="IP Number">{ip_no ? ip_no : '--'}</Tooltip></h6>
                                    </div>
                                </div>
                                <div className="justify-content-center">
                                    <div className="col-12" style={{ display: 'flex',paddingLeft:'0px' }}>
                                        {(preauthSchema !== undefined) && <React.Fragment>
                                            {preauthSchema
                                                .map((feild, key) => {
                                                    if (feild.element === 'select2') {
                                                        return (
                                                            <React.Fragment key={key}>

                                                                <div
                                                                    className={`${feild.className
                                                                        ? feild.className
                                                                        : 'col '} ${feild.name}`}
                                                                    key={key} style={{paddingLeft:'0px'}}>
                                                                    <p className="data-label mb-1 pt-1 pr-2">{feild.title}</p>
                                                                    <Select2
                                                                        Queuedata={formData}
                                                                        selectdata={feild}
                                                                        {...this.props}
                                                                        {...this.state}
                                                                        onselectChanges={this
                                                                            .handleChange
                                                                            .bind(this)}
                                                                    /> {feild
                                                                        .errors
                                                                        .map((error, eKey) => {
                                                                            return (
                                                                                <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                                            );
                                                                        })}
                                                                </div>

                                                            </React.Fragment>
                                                        )
                                                    }

                                                })}

                                        </React.Fragment>}
                                    </div>
                                </div>
                                {/* <p className="text-center mb-5">All files access in pre-auth submit </p> */}
                                <div className="justify-content-center">
                                <div className="financial-table table-responsive mt-5">
                                    {preauthFileSchema.map((feild, key) => {
                                        if (feild.visible) {
                                            return (<React.Fragment key={key}>
                                                <div className="d-inline-flex w-100">
                                                    <h4 className="data-label w-100" style={{ textTransform:'initial' }}>{feild.title}</h4>
                                                </div>
                                                <div className="financial-table table-responsive">
                                                    <Tableantd form_table={'additional_packages'} {...this.props} {...this.state} table_data={feild.Specification} addon_feild={feild} change={this.handleChange.bind(this)} deleteLineItem={this.deleteRow.bind(this)} />

                                                </div>
                                            </React.Fragment>)
                                        }
                                    })}
                                </div>
                                </div>
                                
                                <div className="text-center">
                                    <button className="btn btn-success mt-5" onClick={() => { this.submitPreAuth(preauthdata) }}>Submit</button>
                                </div>

                            </React.Fragment>
                        }
                    </Spin>
                </Modal>
                <Modal
                    title=''
                    centere
                    footer={null}
                    width='70%'
                    zIndex='1021'
                    closable={false}
                    maskClosable={false}
                    destroyOnClose={true}
                    //visible={viewpdf}
                    >
                    <Spin spinning={this.state.loadding} >
                        <Tooltip title="Close"><CloseOutlined type="close" className="comments-popup-close" onClick={() => this.PDFModelClose()} /></Tooltip>
                        <div
                            style={{
                                border: '1px solid rgba(0, 0, 0, 0.3)',
                                height: '750px',
                            }}
                        >
                            {/* <embed src={`data:application/pdf;base64,${ViewURLPDF}`}   width="100%" height="100%" ></embed> */}
                            <embed src={`data:application/pdf;base64,${ViewURLPDF}`} width="100%" height="100%" ></embed>
                        </div>
                        {/* <embed src={`data:application/pdf;base64,${ViewURLPDF}`}   width="100%" ></embed>
                        <iframe src={`data:application/pdf;base64,${ViewURLPDF}`} width="100%"  ></iframe> */}
                        {/* <a href={`data:application/pdf;base64,${ViewURLPDF}`} download="file.pdf"></a> */}

                    </Spin>
                </Modal>

                <Modal
                    title=''
                    centere
                    footer={null}
                    width='95%'
                    height='95%'
                    zIndex={1021}
                    closable={false}
                    maskClosable={false}
                    destroyOnClose={true}
                    visible={viewHistory}>
                    <Spin spinning={this.state.loadding} >
                        {viewHistory &&
                            <React.Fragment>
                                <Tooltip title="Close"><CloseOutlined type="close" className="comments-popup-close" onClick={() => this.viewHistoryModelClose()} /></Tooltip>
                                <h4 className="text-center pb-3">Payer History</h4>
                                
                                <div className="row pb-3">
                                    <div className="col-6 my-auto">
                                        <h6 className="mb-0"> <Tooltip title="Patient Name">{patient_name ? patient_name : '--'}</Tooltip></h6>
                                    </div>
                                    <div className="col-2 my-auto">
                                        <h6 className="mb-0"> <Tooltip title="UMR Number">{umr_no ? umr_no : '--'}</Tooltip></h6>
                                    </div>
                                    <div className="col-2 my-auto">
                                        <h6 className="mb-0"> <Tooltip title="IP Number">{ip_no ? ip_no : '--'}</Tooltip></h6>
                                    </div>
                                </div>
                                <div className="financial-table table-responsive pop-table">
                                    <table className="table table-hover table-bordered mb-0 bg-white">
                                        <thead style={{ backgroundColor: '#084b69' }} >
                                            <tr>
                                                {/* <td className="text-capitalize align-middle text-center">History ID</td> */}

                                                {thead.map((head, key) => {

                                                    return (<td className="text-capitalize align-middle" key={key} >{head['text']}</td>)
                                                })}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {patientHistory.map((body, key) => {
                                                return (<tr key={key}>
                                                    {/* onClick={this.navigateTo.bind(this,body)} style={{cursor: 'pointer'}} */}
                                                    {/* <td>{(key + 1) + (page_data_count > 1 ? 20 * (page_data_count > 2 ? (page_data_count - 1) : 1) : 0)}</td> */}
                                                    {thead.map((head, Hkey) => {

                                                        if (head['key'] === 'payer_updated_time') {
                                                            return (<td>{body[head['key']] ? moment(body[head['key']]).format('DD-MM-YYYY HH:mm:ss') : '--'}</td>)
                                                        }
                                                        if (head['key'] === 'preauth_submited_time') {
                                                            return (<td>{body[head['key']] ? moment(body[head['key']]).format('DD-MM-YYYY HH:mm:ss') : '--'}</td>)
                                                        }
                                                        if (head['key'] === 'approveddate') {
                                                            return (<td>{body[head['key']] ? moment(body[head['key']]).format('DD-MM-YYYY HH:mm:ss') : '--'}</td>)
                                                        }
                                                        return (
                                                            <td className="text-capitalize">
                                                                {(body[head['key']] !== null && body[head['key']] !=='') ? body[head['key']] : '--'}
                                                            </td>
                                                        )

                                                    })
                                                    }

                                                </tr>)
                                            })}
                                            {(patientHistory && patientHistory.length === 0) && <React.Fragment>

                                                <tr>
                                                    <td colSpan={tableHead.length + 1} className="text-center">
                                                        <img src={homepage+"/assets/images/icons/no-data.svg"} alt="" />
                                                        <p className="no-data mb-0">No Data</p>
                                                    </td>
                                                </tr>

                                            </React.Fragment>}
                                        </tbody>
                                    </table>
                                    <div className="text-center m-4">
                                        <button className="btn btn-next" onClick={() => this.viewHistoryModelClose()}> Close</button>
                                    </div>
                                    {/* {docTypes.map((data, key) => {
                            return (
                                <div className="d-flex flex-column mb-3">
                                    <div className="d-inline-flex w-100">
                                        <span className="mt-1 w-75"> {key + 1}. {data.document_type}</span>
                                        
                                        {(data.status !== true) && <Uploadlayer {...this.props} {...this.state} />}
                                    </div>                                    
                                        {data.status && <span class="badge badge-success my-auto" style={{width: '60px'}}>Verified</span>}
                                        {(data.status == false) && <span class="badge badge-danger my-auto" style={{width: '60px'}}>Rejected</span>}
                                     <span><a href="#" target="_blank">{data.preupload}</a></span>
                                </div>
                            )
                        })} */}
                                </div>

                            </React.Fragment>
                        }
                    </Spin>
                </Modal>
            </div>
        )
    }
}

export default PerAuthWorklistNew;